import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { IKeyValueInterface } from './../../shared/config';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { WeGoConfig, IAPIResponse } from '../../shared/config';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { ForgotPasswordModel } from '../models/forgotpassword.model';
import { ForgotPasswordService } from '../models/forgotpassword.service';

@Component({
  selector: 'wego-forgotpassword',
  template: require('../views/changepassword.component.html'),
  providers: [ForgotPasswordService],
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  isLoading: boolean;
  errorMessage: string;
  model: ForgotPasswordModel;
  errorModel: IKeyValueInterface[];
  message: string;
  private sub: any;

  constructor(private forgotpasswordService: ForgotPasswordService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private translate: TranslateService,
    private authService: AuthService) {

  }

  ngOnInit() {
    this.translate.setDetectedLang();
    this.model = new ForgotPasswordModel;
    this.GetPersonActivationCodeId();
  }

  onSubmit(forms: any) {
    this.SubmitChangePassword();
  }

  public GetPersonActivationCodeId() {
    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        if (params['activationLink'] != '') {
          this.forgotpasswordService.CheckActivationCode((params['activationLink']))
            .subscribe(
            res => {
              if (!res.data) {
                this.router.navigate(['/Linkexpired']);
              }
              this.model.personActivationLink = params['activationLink'];
            },
            error => {
              this.errorMessage = this.authService.HandleErrorStatusCode(error);
              this.isLoading = false;
            });
        }
      });
  }

  public SubmitChangePassword() {
    this.forgotpasswordService.SubmitChangePassword(this.model)
      .subscribe(
      res => {
        if (res.data == null) {
          this.router.navigate(['changepassword/success']);
        }
        else {
          this.errorModel = res.error;
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
      );
  }

  ngOnDestroy() { }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/forgotpassword/components/changepassword.component.ts